import { vue3Debounce } from 'vue-debounce'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive('debounce', vue3Debounce({ lock: true }))
})
